"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const RecurrentOptionItem_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/RecurrentOptionItem.vue"));
let CRUDModal = class CRUDModal extends vue_property_decorator_1.Vue {
    mounted() {
        const element = document.getElementsByClassName('bmfw-modal--custom_prequote')[0];
        if (element) {
            element.style.maxWidth = '45rem';
            element.style.boxShadow = '0px 0px 50px rgba(0, 0, 0, 0.2)';
        }
    }
    confirmRemoval() {
        this.$emit('confirmRemoval');
    }
    dismissModal() {
        this.$emit('dismissModal');
    }
    back() {
        this.$emit('back');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CRUDModal.prototype, "farm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CRUDModal.prototype, "fields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'remove' })
], CRUDModal.prototype, "state", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CRUDModal.prototype, "feedback", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], CRUDModal.prototype, "feedbackMessages", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], CRUDModal.prototype, "loading", void 0);
CRUDModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            Button: bmk_ui_framework_1.Button,
            Loading: bmk_ui_framework_1.Loading,
            Mail: lucide_vue_next_1.Mail,
            RecurrentOptionItem: RecurrentOptionItem_vue_1.default,
            CheckBox: bmk_ui_framework_1.CheckBox,
            BinIcon: bmk_ui_framework_1.BinIcon,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon
        },
    })
], CRUDModal);
exports.default = CRUDModal;
